import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { push } from 'connected-react-router';

import Button from '../../../Button';
import TaskList from './List';
import TaskFilters from './Filters';

const YourTasks = props => (
  <div className="wrap tools tasks">
    <h1>Your Tasks</h1>
    <TaskList />
    <div className={`task-filters weight ${props.pathway}`}>
      <TaskFilters />
    </div>
    <div className="justifycentre">
      <Button onClick={() => props.dispatch(push('/dashboard'))} label="Return to Dashboard" />
    </div>
  </div>
);

YourTasks.propTypes = {
  pathway: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(state => ({
  pathway: state.pathway,
}), dispatch => ({ dispatch }))(YourTasks);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/Task/index.jsx